/**
 * Anchor.js
 * Created on 23-apr-2014
 * 
 * ValueObject for defining anchor point, relative to stage width and height (so x,y in range 0..1)
 * 
 * @author Reinier Feijen for Ranj
 **/

export default class Anchor extends createjs.Point {

    constructor(x, y) {
        super(x, y);
    }

}

Anchor.C = new Anchor(.5,.5);
Anchor.T = new Anchor(.5,0);
Anchor.TL = new Anchor(0,0);
Anchor.TR = new Anchor(1,0);
Anchor.L =  new Anchor(0,.5);
Anchor.R = new Anchor(1,.5);
Anchor.B = new Anchor(.5,1);
Anchor.BL = new Anchor(0,1);
Anchor.BR = new Anchor(1,1);

